let defaultTitle = null;

export default function setWebsiteTitle(req) {
    if (defaultTitle === null) {
        defaultTitle = document.title;
    }

    if (!req.value || !req.value.title) {
        document.title = defaultTitle;
        return;
    }

    document.title = req.value.title;
}
